$(document).ready(function() {
    $(document).on('click', '.main-menu-link', function() {
        if ($('.header-accordion-content').is(':visible')) {
            $('.header-accordion-content').slideUp(300);
            $('.accordion-icon').removeClass('accordion-icon-show');
        }
        if ($(this).next('.header-accordion-content').is(':visible')) {
            $(this).next('.header-accordion-content').slideUp(300);
            $(this).find('.accordion-icon').removeClass('accordion-icon-show');
        } else {
            $(this).next('.header-accordion-content').slideDown(300);
            $(this).find('.accordion-icon').addClass('accordion-icon-show');
        }
    });


});